export const loginBtnColor = '#59B2E0';
export const resetPassWordStyle = { backgroundColor: '#f0af7e', color: 'black', fontSize: 'small', padding: '0 5px' };
